import { connect } from "react-redux";
import React, { useContext } from "react";
import { apiIdle, apiRequest } from "../../data/redux/actions/api";
import { ScrollView } from "react-native-gesture-handler";
import { SelectInputM } from "../../student/account/onboarding/SelectInputM";
import { DimensionsContext } from "../../common/utils/mobileUtils";
import TextInputM from "../../common/components/input/TextInputM";
import { theme } from "../../common/theme/theme";
import TextM from "../../common/components/text/TextM";
import { roomTypes } from "../../data/constants/formConstants";
import { View } from "react-native";
import { findClosestNextOccurrence } from "../../student/account/onboarding/LiveRoomCard";
import { capitalize, formatMinutes } from "../../data/utility/Utils";
import moment from "moment";
import { Checkbox } from "react-native-paper";
import { useController } from "react-hook-form";
import FilledButtonM from "../../common/components/button/FilledButtonM";
import { DialogM } from "../../common/components/alert/dialog/Dialog";
import { ListGroupM } from "../../common/components/list/ListGroupM";
import { ListItemM } from "../../common/components/list/ListItemM";

const SelectDelayComponent = (props) => {
  const {
    delayOptions,
    control,
    goToNextStep,
    register,
    errors,
    serverError,
    setFormValues,
    formValues,
    field,
  } = props;

  const dimensions = useContext(DimensionsContext);

  const { field: lateMinutes } = useController({
    name: "late_minutes",
    control,
  });

  return (
    <>
      <View
        style={{
          marginBottom: 10,
          marginTop: 20,
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <ListGroupM
          options={delayOptions}
          style={{
            // marginHorizontal: 20
            marginBottom: 70,
          }}
          itemHeight={70}
          renderItem={(item) => {
            return (
              <ListItemM
                isFirst={item.index === 0}
                isLast={item.index === delayOptions?.length - 1}
                onPress={() => {
                  lateMinutes.onChange(item.item?.value);
                  setFormValues({
                    ...control?._formValues,
                    late_minutes: item.item?.value,
                  });
                  if (item.item?.value === "more")
                    DialogM.show({
                      text1:
                        "Plus de 15 minutes de retard n’est pas acceptable, il faut donc faire une demande d’absence",
                      buttonText1: "Demande d'absence",
                      buttonColor1: theme.colors.error,
                      onPress: () => {
                        goToNextStep();
                      },
                      buttonText2: "Annuler",
                    });
                  else goToNextStep();
                }}
                itemHeight={70}
                selected={item.item?.value === lateMinutes.value}
                option={item.item}
                disabled={item.item?.disabled}
              />
            );
          }}
        />
      </View>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    rescheduling_reasons: state.data.staticData?.rescheduling_reasons,
  };
};

const mapDispatchToProps = {
  apiRequest,
  apiIdle,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectDelayComponent);
